import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './frontend/css/toastify.css';
import HomePage from "./frontend/landing/home";
import Login from "./frontend/pages/login";
import ElectionForm from "./frontend/pages/electionform"; 
import ElectionResults from "./frontend/pages/results";
import Candidates from "./frontend/pages/candidates";
import ErrorPage from "./frontend/pages/error";
import { AuthProvider, useAuth } from "./AuthContext"; // Added useAuth
import ProtectedRoute from "./ProtectedRoute";
import ProtectedLayout from "./ProtectedLayout";
import Guidelines from "./frontend/pages/guidelines";
import ElectionReturn from "./frontend/pages/electionretun";

const AppContent = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth(); // Check auth state here
  
  const isFormActive = location.pathname === "/electionform";

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="toast-container"
        toastClassName="toast"
      />

      {/* FIX: Only render the persistent ElectionForm if the user is authenticated.
        This prevents the ProtectedRoute from redirecting unauthenticated users 
        who are trying to access public pages like /guidelines.
      */}
      {isAuthenticated && (
        <ProtectedRoute>
          <ElectionForm isActive={isFormActive} />
        </ProtectedRoute>
      )}

      <Routes>
        {/* PUBLIC ROUTES: Accessible to everyone */}
        <Route path="/" element={<Login />} />
        <Route path="/candidates" element={<Candidates />} />
        <Route path="/guidelines" element={<Guidelines />} />
        <Route path="/electionreturn" element={<ElectionReturn />} />
        
        {/* PROTECTED ROUTES: Only accessible if logged in */}
        <Route path="/home" element={<ProtectedRoute><ProtectedLayout /></ProtectedRoute>}>
          <Route index element={<HomePage />} />
        </Route>
        
        {/* Placeholder for /electionform logic handled above */}
        <Route path="/electionform" element={<ProtectedRoute><></></ProtectedRoute>} />
        
        <Route path="/electionresults" element={<ProtectedRoute><ElectionResults /></ProtectedRoute>} />
        
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;